import React from "react";
import PropTypes from "prop-types";

const Add = (props) => {
  return (
    <div>
      <i className="fa fa-plus add" aria-hidden="true" onClick = {props.addGrades}>
        <span>Add</span>{" "}
      </i>
    </div>
  );
};

Add.propTypes = {};

export default Add;
